import { Typography } from '@mui/material';
import { NotificationDialog } from './NotificationDialog';

const LCI_REPORT_DIALOG_KEY = 'lci-report-5/16';

export const LciReportDialog = () => {
  return (
    <NotificationDialog notificationKey={LCI_REPORT_DIALOG_KEY}>
      <Typography>
        New on demand reports are available within the LCI dashboard. Click the
        green download button at the top right of the dashboard to explore this
        new feature.
      </Typography>
    </NotificationDialog>
  );
};
